export enum InvoicePaymentStatus {
  OPEN = 'open',
  PAID = 'paid',
}
export type Invoice = {
  id: number;
  businessInvoiceId: string;
  invoiceDate: string;
  amount: number;
  paymentStatus: InvoicePaymentStatus;
  campaignId: string;
  campaignName: string;
};
